import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { login } from '../../redux/actions/authActions';
import { Container, TextField, Button, Typography, Box, CircularProgress, Paper, FormControlLabel, Checkbox, IconButton, InputAdornment, Alert } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { textFieldStyles } from '../../styles/textFieldStyles';
import { actionButtonStyles } from '../../styles/actionButton';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const { t } = useTranslation(['common', 'forms', 'buttons']);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    keepLoggedIn: false,
  });

  const [showPassword, setShowPassword] = useState(false);

  const { email, password, keepLoggedIn } = formData;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthenticated, loading, error } = useSelector((state) => state.userLoaded);

  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from); // Redirect to the original page or dashboard if no original page
      
    }
  }, [isAuthenticated, navigate, location.state]);

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(login(email, password, keepLoggedIn));
  };

  return (
    <Container>
      <Container component="main" maxWidth="xs">
        <Box elevation={3} sx={{
            padding: 4,
            
            backgroundColor: "white",
            boxShadow: "0px 4px 16px rgba(0,0,0,0.1)", // Reduced shadow spread
            border: "none",
            borderRadius: 0,
          }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
            <img src="lp-logo.png" alt="Logo" style={{ width: '200px' }} />
          </Box>
          {error && <Alert severity="error">{error}</Alert>}
          <form onSubmit={onSubmit}>
            <TextField
              
              margin="normal"
              required
              fullWidth
              id="email"
              label={t('forms:labels.emailAddress')}
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={onChange}
              size='small'
              sx={{...textFieldStyles(), marginTop: 4}}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label={t('forms:labels.password')}
              type={showPassword ? 'text' : 'password'}
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={onChange}
              
              size='small'
              sx={{...textFieldStyles(), marginTop: 4}}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <FormControlLabel
              control={<Checkbox checked={keepLoggedIn} onChange={(e) => setFormData({ ...formData, keepLoggedIn: e.target.checked })} name="keepLoggedIn" />}
              label={t('forms:labels.keepLoggedIn')}
              sx={{paddingBottom: 2}}
            />
            <Button
              type="submit"
              fullWidth
              sx={actionButtonStyles()}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : t('forms:labels.signIn')}
            </Button>
            <Typography align="center">
              <Link to="/forgot-password" style={{color: '#2B80B6', marginTop: 4}}>{t('forms:labels.forgotPassword')}</Link>
            </Typography>
          </form>
        </Box>
      </Container>
    </Container>
  );
};

export default Login;
